import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue3Transitions from 'vue3-transitions';
import VueSweetalert2 from 'vue-sweetalert2';
import '@/assets/css/main.css';


createApp(App).use(store).use(router).use(Vue3Transitions).use(VueSweetalert2).mount('#app')
